export default __webpack_public_path__ + "static/media/imgPerfilLipidico.b8e24c9a.png";